var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_212_151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.00976562 7.03076V30.8304L13.3557 17.531L-0.00976562 7.03076Z",
    fill: "#B8963A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6176 21.4805C19.4364 21.6229 19.2182 21.6944 19.0001 21.6944C18.7819 21.6944 18.5638 21.6235 18.3826 21.4805L14.9398 18.7759L1.40771 32.2407H36.5924L23.0603 18.7759L19.6176 21.4805Z",
    fill: "#B8963A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0098 30.8304V7.03076L24.6443 17.531L38.0098 30.8304Z",
    fill: "#B8963A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3912 5.75879H1.60889L19.0001 19.4224L36.3912 5.75879Z",
    fill: "#B8963A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_212_151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.4d02eeb7a248a800a0587bc71bf3937f.svg";
export { ForwardRef as ReactComponent };